export default __webpack_public_path__ + "static/media/computer.103843c4.png";